import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../i18n";
import { FadeUp } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

export const CTA = () => {
  const { lang } = useLang();
  const t = {
    fr: { tag: "Prêt à décoller ?", title: "Discutons de votre projet.", lead: "Devis gratuit sous 24-48 h. Réponse par un pilote certifié, pas un commercial.", btn: "Demander un devis", btn2: "Voir nos services" },
    en: { tag: "Ready for takeoff?", title: "Let's discuss your project.", lead: "Free quote within 24-48h. Answered by a certified pilot, not a salesperson.", btn: "Request a quote", btn2: "See our services" },
  }[lang];

  return (
    <section className="py-24 md:py-32 bg-[#070708] border-y border-white/10 relative overflow-hidden">
      <div className="absolute inset-0 grid-lines opacity-20" />
      <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-16 relative text-center">
        <FadeUp>
          <span className="font-mono-p text-xs uppercase tracking-[0.25em] text-primary-c">{t.tag}</span>
          <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight mt-5 max-w-3xl mx-auto leading-[1.02]">{t.title}</h2>
          <p className="text-white/60 mt-6 max-w-xl mx-auto leading-relaxed">{t.lead}</p>
          <div className="mt-10 flex flex-wrap gap-4 justify-center">
            <Link to="/contact" data-testid="cta-contact" className="group inline-flex items-center gap-2 bg-[var(--primary)] text-black font-medium px-8 py-4 rounded-full hover:bg-white transition-colors duration-300">
              {t.btn} <ArrowUpRight size={18} className="group-hover:rotate-45 transition-transform duration-300" />
            </Link>
            <Link to="/services" className="inline-flex items-center gap-2 border border-white/25 px-8 py-4 rounded-full hover:border-[var(--primary)] hover:text-primary-c transition-colors duration-300">{t.btn2}</Link>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};
